module.exports = __webpack_public_path__ + "img/shippingSoftwareHeader.d4893146.svg";